export const siteMeta = {
  name: "海角黑料",
  tagline: "人物脉络梳理站",
  updated: "2026.09.10",
};

export const heroStats = [
  { label: "已整理人物", value: "06", unit: "条" },
  { label: "关系节点", value: "05", unit: "处" },
  { label: "可交叉核实", value: "12", unit: "项" },
  { label: "最近更新", value: "09.10", unit: "" },
];

export const heroPersons = [
  {
    id: "p1",
    name: "林某",
    alias: "主当事人",
    tag: "事件起点",
    line: "最早被公开讨论的一方，公开说法与现场描述存在出入。",
    image: "https://readdy.ai/api/search-image?query=editorial%20silhouette%20portrait%20of%20an%20anonymous%20adult%20figure%20against%20warm%20beige%20neutral%20studio%20backdrop%2C%20soft%20muted%20documentary%20lighting%2C%20desaturated%20tones%2C%20faceless%2C%20subtle%20film%20grain%2C%20minimal%20composition%2C%20high%20detail&width=400&height=500&seq=hj-person-01&orientation=portrait",
  },
  {
    id: "p2",
    name: "周某",
    alias: "关键配角",
    tag: "口径稳定",
    line: "由共同好友引荐进入事件，多个时间点留下可验证痕迹。",
    image: "https://readdy.ai/api/search-image?query=side%20profile%20silhouette%20portrait%20of%20an%20unnamed%20adult%20figure%20on%20warm%20sand%20colored%20studio%20background%2C%20gentle%20soft%20light%2C%20muted%20earthy%20palette%2C%20anonymized%20blurred%20identity%2C%20editorial%20photography%2C%20clean%20minimal%20frame&width=400&height=500&seq=hj-person-02&orientation=portrait",
  },
  {
    id: "p3",
    name: "阿May",
    alias: "关联账号",
    tag: "首轮放料",
    line: "最早放出零散片段的网名，指向模糊但带动第一轮讨论。",
    image: "https://readdy.ai/api/search-image?query=back%20view%20anonymous%20seated%20figure%20wearing%20neutral%20knitwear%2C%20warm%20clay%20toned%20plain%20studio%20background%2C%20calm%20documentary%20light%2C%20desaturated%20editorial%20style%2C%20no%20visible%20face%2C%20soft%20grain%20texture&width=400&height=500&seq=hj-person-03&orientation=portrait",
  },
  {
    id: "p4",
    name: "K先生",
    alias: "疑似中间人",
    tag: "身份存疑",
    line: "只出现在对话截图里，从未露面，是脉络中最大的空白点。",
    image: "https://readdy.ai/api/search-image?query=shadowed%20half%20hidden%20silhouette%20of%20an%20unknown%20adult%20against%20warm%20taupe%20studio%20wall%2C%20low%20key%20soft%20lighting%2C%20muted%20brown%20and%20cream%20palette%2C%20mysterious%20editorial%20portrait%2C%20anonymized%2C%20fine%20grain&width=400&height=500&seq=hj-person-04&orientation=portrait",
  },
];

export const archiveList = [
  {
    id: "a1",
    index: "01",
    title: "主当事人林某：公开口径与现场描述的第一处出入",
    summary:
      "事件起点人物，其自述的行踪与可查的公开记录在时间上对不齐。本页先把「他说了什么」和「能查到什么」分开列，再判断哪些属于当事人身份背景的硬信息。",
    tag: "主当事人",
    weight: "高",
  },
  {
    id: "a2",
    index: "02",
    title: "关键配角周某：不在风口，却留下最多可核实痕迹",
    summary:
      "并非事件发起者，但同乡、共事两条线都把其与主角连在一起。其身份背景相对简单，反而成为校验整条人物关系是否成立的关键参照。",
    tag: "关键配角",
    weight: "高",
  },
  {
    id: "a3",
    index: "03",
    title: "关联账号阿May：最早放料，却最难以核实",
    summary:
      "第一个放出只言片语的网名，内容零散、指向模糊。它能解释讨论为何开始，却无法解释人物是谁，属于需要单独标注可信度的线索源。",
    tag: "关联账号",
    weight: "中",
  },
  {
    id: "a4",
    index: "04",
    title: "第三方见证者老陈：与双方都保持距离的独立口径",
    summary:
      "早年曾是阿May的房东，与主当事人和配角均无直接往来。其说法独立，被用来判断公开时间线是否站得住，是人物脉络里的对照样本。",
    tag: "第三方",
    weight: "中",
  },
  {
    id: "a5",
    index: "05",
    title: "疑似中间人K先生：只存在于截图中的连接点",
    summary:
      "没有露面、没有实名、没有独立信源，仅出现在两段对话截图之间。他是关系脉络中最大的空白，也是目前最难给出身份背景结论的人物。",
    tag: "存疑节点",
    weight: "低",
  },
  {
    id: "a6",
    index: "06",
    title: "后续补充苏某：事件发酵后才进入视野的补位者",
    summary:
      "与主线关联较弱，但补上了几处缺失的时间缺口。在此仅作为人物关系的补充记录，不参与主当事人身份的判断。",
    tag: "补充信息",
    weight: "低",
  },
];

export const relationNodes = [
  {
    id: "r1",
    label: "林某",
    role: "主当事人",
    edge: "同乡 + 曾共事",
    target: "周某",
    note: "整条脉络的起点，两人的交集最早、也最容易追溯。",
  },
  {
    id: "r2",
    label: "周某",
    role: "关键配角",
    edge: "线上先有交集",
    target: "阿May",
    note: "线下是否见过面，至今没有一致说法。",
  },
  {
    id: "r3",
    label: "阿May",
    role: "关联账号",
    edge: "早期租赁关系",
    target: "老陈",
    note: "老陈口径独立，构成时间线上的对照。",
  },
  {
    id: "r4",
    label: "K先生",
    role: "空白节点",
    edge: "位置不明",
    target: "两段对话",
    note: "只出现在截图中，连接前后两段记录，身份待考。",
  },
  {
    id: "r5",
    label: "苏某",
    role: "补充信息",
    edge: "补齐时间缺口",
    target: "主线末端",
    note: "进入视野较晚，仅作为脉络收尾。",
  },
];

export const relationSummary = [
  {
    id: "rs1",
    title: "起点关系：主当事人与关键配角",
    summary: "同乡兼同事，是把两人绑在一起的第一条硬线索，也是判断人物关系的基准线。",
  },
  {
    id: "rs2",
    title: "线上关系：账号与讨论者之间",
    summary: "从网名发出的内容推动了讨论，但账号背后是谁，仍无法与真实身份对上。",
  },
  {
    id: "rs3",
    title: "空白节点：中间人的位置",
    summary: "K先生同时出现在两段对话里，却没有任何独立信源，是整条人物脉络的断点。",
  },
];

export const backgroundDives = [
  {
    id: "b1",
    title: "身份基本信息逐条核对",
    summary:
      "把公开可查的出生地、职业与教育经历拆成条目，逐条标注出处与可信度，能查实的留下，查不到的不补写。",
    points: ["公开记录优先于传闻", "每条信息标注出处", "无法核实的单独归档"],
    image: "https://readdy.ai/api/search-image?query=archival%20desk%20scene%20with%20stacked%20paper%20files%20and%20index%20cards%2C%20warm%20cream%20and%20clay%20paper%20tones%2C%20soft%20natural%20window%20light%2C%20shallow%20depth%20of%20field%2C%20muted%20editorial%20still%20life%2C%20minimal%20composition&width=1200&height=800&seq=hj-dive-01&orientation=landscape",
  },
  {
    id: "b2",
    title: "时间线还原与矛盾点标注",
    summary:
      "按公开信息把关键节点排开，区分「有出处」与「仅有说法」，把互相冲突的两处时间单独标出来，而不是强行抹平。",
    points: ["节点按时间排序", "冲突处保留双版本", "争议点不写成定论"],
    image: "https://readdy.ai/api/search-image?query=vintage%20wall%20clock%20and%20timeline%20notes%20pinned%20on%20warm%20linen%20board%2C%20soft%20diffused%20daylight%2C%20muted%20beige%20and%20terracotta%20palette%2C%20editorial%20documentary%20still%20life%2C%20calm%20minimal%20mood&width=1200&height=800&seq=hj-dive-02&orientation=landscape",
  },
  {
    id: "b3",
    title: "关系与动机的有限推测",
    summary:
      "只保留能由已知信息支撑的推测，并明确标注这是推断而非结论。人物动机部分刻意留白，避免把猜测当成事实。",
    points: ["推断与事实分栏", "推测标注依据", "不越界下结论"],
    image: "https://readdy.ai/api/search-image?query=connected%20thread%20pins%20and%20string%20on%20warm%20cork%20board%20with%20blank%20note%20cards%2C%20soft%20side%20light%2C%20muted%20amber%20and%20sand%20tones%2C%20minimal%20editorial%20close%20up%2C%20restrained%20lines&width=1200&height=800&seq=hj-dive-03&orientation=landscape",
  },
];

export const discussionMeta = {
  participants: "1,248",
  threads: "326",
  hottest: "主当事人时间线对不齐，是记录错误还是口径问题？",
};

export const comments = [
  {
    id: "c1",
    name: "旧城观察",
    time: "12 分钟前",
    initial: "旧",
    text: "把「有出处的」和「只有说法的」分开列这个做法很舒服，至少知道自己看的是哪一档信息。",
    likes: 86,
    replies: 12,
  },
  {
    id: "c2",
    name: "夜航船",
    time: "48 分钟前",
    initial: "夜",
    text: "K先生那段我反复看了两遍，确实只出现在截图里，位置说不清就先空着，比硬安一个人靠谱。",
    likes: 143,
    replies: 27,
  },
  {
    id: "c3",
    name: "折页本",
    time: "2 小时前",
    initial: "折",
    text: "希望能把时间线那张对照表做成可以逐条看的，现在一次看完有点吃力，但内容是真细。",
    likes: 64,
    replies: 8,
  },
  {
    id: "c4",
    name: "半盏茶",
    time: "5 小时前",
    initial: "半",
    text: "支持只写能核实的。人物身份背景这块本来就容易被带偏，留白反而是负责的做法。",
    likes: 208,
    replies: 41,
  },
  {
    id: "c5",
    name: "路过的人",
    time: "昨天",
    initial: "路",
    text: "阿May和老陈这条线之前没注意到，看完才明白为什么时间线能对上一部分。",
    likes: 52,
    replies: 6,
  },
];

export const faqs = [
  {
    id: "f1",
    q: "海角黑料当事人到底是谁？",
    a: "本页按公开信息可核实的程度整理，主当事人以化名「林某」呈现。凡是没有独立信源支撑的姓名和身份，都不在这里补写，以免把传闻当成事实。",
  },
  {
    id: "f2",
    q: "海角黑料主角和配角之间是什么关系？",
    a: "起点是主当事人与关键配角的同乡加共事关系，随后延伸到线上账号与第三方见证者。整条人物关系在「关系脉络」中按节点逐条列出，空白节点单独标注。",
  },
  {
    id: "f3",
    q: "页面里的信息哪些是能核实的？",
    a: "带「可交叉核实」标记的条目，至少有两个相互独立的信源指向同一结论；只有单一说法的内容会被归入存疑，不会与已核实信息混在一起。",
  },
  {
    id: "f4",
    q: "为什么没有给出真实姓名和照片？",
    a: "本页侧重人物脉络梳理，而非指向具体个人。涉及身份背景的部分只保留必要信息，配图均使用匿名化的示意图像。",
  },
];

export const footerLinks = [
  { label: "人物档案", href: "#archive" },
  { label: "关系脉络", href: "#relation" },
  { label: "身份深挖", href: "#background" },
  { label: "讨论区", href: "#discussion" },
  { label: "常见问题", href: "#faq" },
];